import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { SchwabContactSyncSettings } from './SchwabContactSyncSettings'

export const SchwabSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <SchwabContactSyncSettings /> }]
}
